import React, { useState } from "react";
import "../Style/Saasdoubts.css";

import arrowIcon from "../assets/blue-arrow.png";

const faqData = [
  {
    question: "How long does it take to develop a SaaS product?",
    answer:
      "The development timeline depends on your project requirements, features, integrations, and complexity. A Minimum Viable Product (MVP) typically takes 8–12 weeks, while enterprise SaaS platforms with advanced functionality may require 4–8 months. We follow an agile development approach for faster delivery and continuous improvements.",
  },
  {
    question: "How much does SaaS product development cost?",
    answer:
      "SaaS development costs vary based on project scope, technology stack, cloud infrastructure, integrations, UI/UX design, and custom functionality. We provide transparent pricing with flexible engagement models tailored to startups, SMEs, and enterprise businesses.",
  },
  {
    question: "Can the SaaS platform scale as my business grows?",
    answer:
      "Yes. Our SaaS solutions are built using scalable cloud architecture that supports increasing users, data, and business operations without compromising performance. The platform can easily evolve as your business expands.",
  },
  {
    question: "Can you upgrade or improve my existing SaaS platform?",
    answer:
      "Absolutely. We modernize legacy SaaS applications by improving performance, redesigning user interfaces, adding new features, migrating to cloud infrastructure, strengthening security, and integrating advanced technologies to keep your software competitive.",
  },
  {
    question: "Will my SaaS platform be secure?",
    answer:
      "Yes. Security is integrated into every stage of development. We implement secure authentication, data encryption, role-based access control, API protection, regular security testing, and cloud security best practices to safeguard your business and customer data.",
  },
  {
    question: "Can you integrate third-party tools and services?",
    answer:
      "Yes. We integrate payment gateways, CRM systems, ERP software, marketing platforms, cloud storage, AI services, analytics tools, communication APIs, and other third-party solutions to enhance your SaaS platform's capabilities.",
  },
  {
    question: "Do you provide maintenance and support for SaaS products?",
    answer:
      "Yes. We offer ongoing SaaS maintenance, performance monitoring, security updates, feature enhancements, bug fixes, cloud optimization, and technical support to ensure your platform remains secure, reliable, and up to date.",
  },
];

const Saasdoubt = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="saasdoubts-section">
      <div className="saasdoubts-container">
        <span className="saasdoubts-eyebrow">FAQ</span>

        <h2 className="saasdoubts-title">
          Frequently Asked Questions About SaaS Development
        </h2>

        <div className="saasdoubts-faq-grid">
          {faqData.map((item, index) => (
            <div
              className={`saasdoubts-faq-item ${
                activeIndex === index ? "active" : ""
              }`}
              key={index}
            >
              <div
                className="saasdoubts-faq-question-row"
                onClick={() => toggleFaq(index)}
              >
                <span className="saasdoubts-faq-number">
                  {String(index + 1).padStart(2, "0")}
                </span>

                <h3 className="saasdoubts-faq-question">{item.question}</h3>

                <button className="saasdoubts-faq-btn" aria-label="Toggle answer">
                  <img
                    src={arrowIcon}
                    alt=""
                    className={`saasdoubts-faq-icon ${
                      activeIndex === index ? "rotate" : ""
                    }`}
                  />
                </button>
              </div>

              <div
                className={`saasdoubts-faq-answer-wrapper ${
                  activeIndex === index ? "show" : ""
                }`}
              >
                <div className="saasdoubts-faq-answer-inner">
                  <p className="saasdoubts-faq-answer">{item.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Saasdoubt;